module.exports = __webpack_public_path__ + "media/new_order.b64ba0a1.mp3";